import React, { useState , useEffect } from 'react';
import { db } from "../firebase";
import { doc, setDoc, getDoc,collection } from "firebase/firestore";

export const UserDetailsForm = ({phoneNumber}) => {
  
  const [isExistingUser, setIsExistingUser] = useState(false);

  const [details, setDetails] = useState({
    phoneNumber: '',
    name: '',
    gender: '',
    email: '',
    birthday: '',
    anniversary: ''
  });

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const userRef = doc(db, "users", details.phoneNumber); 
    // Using phoneNumber as the document ID

    await setDoc(userRef, {
      name: details.name,
      phone: details.phoneNumber,
      gender: details.gender,
      email: details.email,
      birthday: details.birthday,
      anniversary: details.anniversary,
      updatedAt: new Date()
    }, { merge: true }); 
    // merge:true keeps existing fields if not overwritten
 // prepare userData
    const userData = {
      name: details.name,
      phone: details.phoneNumber,
      gender: details.gender,
      email: details.email,
      birthday: details.birthday,
      updatedAt: new Date()
    };

    // ✅ only save anniversary if selected
    if (details.anniversary && details.anniversary.trim() !== "") {
      userData.anniversary = details.anniversary;
    }
    alert("Profile updated successfully!");
  } catch (err) {
    console.error("Error saving profile:", err);
    alert("Failed to save profile");
  }
};

useEffect(() => {
  const fetchUser = async () => {
    if (!phoneNumber) return;

    const userRef = doc(db, "users", phoneNumber);
    const snap = await getDoc(userRef);

     if (snap.exists()) {
        // ✅ user already has details
        setDetails({
          phoneNumber: phoneNumber,
          ...snap.data()
        });
        setIsExistingUser(true); // ← this is the code you asked about
      } else {
        // first-time login
        setIsExistingUser(false); // ← and this
      }
    };

  fetchUser();
}, [phoneNumber]);


  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
      <input
  type="tel"
  value={details.phoneNumber}
  disabled={isExistingUser} // ✅ phone number non-editable if user exists
  onChange={(e) => setDetails({ ...details, phoneNumber: e.target.value })}
  className="w-full px-4 py-3 bg-gray-100 rounded-lg border-0 focus:ring-2 focus:ring-blue-500 transition-all"
  placeholder="Enter phone number"
/>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
       <input
  type="text"
  value={details.name}
  // ✅ make name non-editable if user exists
  onChange={(e) => setDetails({ ...details, name: e.target.value })}
  className="w-full px-4 py-3 bg-gray-100 rounded-lg border-0 focus:ring-2 focus:ring-blue-500 transition-all"
  placeholder="Enter your name"
/>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Gender</label>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setDetails({ ...details, gender: 'Male' })}
             
            className={`flex-1 py-3 px-4 rounded-lg font-medium transition-colors ${
              details.gender === 'Male'
                ? 'bg-gray-800 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            Male
          </button>
          <button
            type="button"
            onClick={() => setDetails({ ...details, gender: 'Female' })}
            
            className={`flex-1 py-3 px-4 rounded-lg font-medium transition-colors ${
              details.gender === 'Female'
                ? 'bg-gray-800 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            Female
          </button>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
        <input
          type="email"
          value={details.email}
          onChange={(e) => setDetails({ ...details, email: e.target.value })}
          className="w-full px-4 py-3 bg-gray-100 rounded-lg border-0 focus:ring-2 focus:ring-blue-500 transition-all"
          placeholder="Enter email"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Birthday</label>
          <input
            type="date"
            value={details.birthday}
            
            onChange={(e) => setDetails({ ...details, birthday: e.target.value })}
            className="w-full px-4 py-3 bg-gray-100 rounded-lg border-0 focus:ring-2 focus:ring-blue-500 transition-all"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Anniversary</label>
          <input
            type="date"
            value={details.anniversary}
            
            onChange={(e) => setDetails({ ...details, anniversary: e.target.value })}
            className="w-full px-4 py-3 bg-gray-100 rounded-lg border-0 focus:ring-2 focus:ring-blue-500 transition-all"
          />
        </div>
      </div>

      <button
        type="submit"
        className="w-full bg-gradient-to-r from-yellow-500 to-orange-500 text-white py-3 px-6 rounded-lg font-semibold  transition-all duration-200 transform hover:scale-[1.02]"
      >
        Save Details
      </button>
    </form>
  );
};